import { useQuery, useQueries, type QueryClient } from '@tanstack/react-query';

import { FILE_STORAGE_QUERY_KEY } from '#apps/client-web/features/file-storage/types/react-query';
import { type FileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';

export const useLoadFileQuery = ({
  fileStorageService,
  queryClient,

  fileId,
}: {
  fileStorageService: FileStorageService;
  queryClient: QueryClient;

  fileId: string;
}) =>
  useQuery(
    {
      queryKey: [FILE_STORAGE_QUERY_KEY, fileId],
      queryFn: fileStorageService.load.bind(fileStorageService, {
        fileId,
      }),
    },
    queryClient,
  );

export const useLoadFilesQuery = ({
  fileStorageService,
  queryClient,

  fileIds,
}: {
  fileStorageService: FileStorageService;
  queryClient: QueryClient;

  fileIds: Array<string>;
}) =>
  useQueries(
    {
      queries: fileIds.map((fileId) => ({
        queryKey: [FILE_STORAGE_QUERY_KEY, fileId],
        queryFn: fileStorageService.load.bind(fileStorageService, {
          fileId,
        }),
      })),
    },
    queryClient,
  );
